// // -----------------------------
// //  GET FIELDS.
// // -----------------------------

// import { ficooInput, ficooDiv, woocommerceFields, ficooShippingAddressDiv, ficooBillingAddressDiv } from "./fields-selectors.js";
// import { __, _x, _n, sprintf } from "@wordpress/i18n";

// import { logger } from "./logger.js";

// // Used to append error div.
// const getTargetContainer = (field) => {
//   switch (field) {
//     case "vat":
//       return ficooDiv.vat;
//     case "taxcode":
//       return ficooDiv.taxcode;
//     case "pec":
//       return ficooDiv.emailpec;
//     case "reccode":
//       return ficooDiv.reccode;
//     case "vatShipping":
//       return ficooShippingAddressDiv.vat;
//       case "taxcodeShipping":
//       return ficooShippingAddressDiv.taxcode;
//     case "pecShipping":
//       return ficooShippingAddressDiv.emailpec;
//     case "reccodeShipping":
//       return ficooShippingAddressDiv.reccode;
//     case "vatBilling":
//       return ficooBillingAddressDiv.vat;
//       case "taxcodeBilling":
//       return ficooBillingAddressDiv.taxcode;
//     case "pecBilling":
//       return ficooBillingAddressDiv.emailpec;
//     case "reccodeBilling":
//       return ficooBillingAddressDiv.reccode;
//     case "woototalwrap":
//       return woocommerceFields.totalwrapper;
//     default:
//       return null;
//   }
// };

// const getTargetInput = (field) => {
//   switch (field) {
//     case "vat":
//       return ficooInput.vat;
//     case "taxcode":
//       return ficooInput.taxcode;
//     case "pec":
//       return ficooInput.emailpec;
//     case "reccode":
//       return ficooInput.reccode;
//     case "checkbox":
//       return ficooInput.checkbox;
//     default:
//       return null;
//   }
// };

// // -----------------------------
// //  ERROR MSG
// // -----------------------------

// function createErrorMessage(message, parametro) {
//   const div = document.createElement("div");
//   div.classList.add("wc-block-components-validation-error");
//   div.setAttribute("role", "alert");

//   const p = document.createElement("p");
//   p.id = `ficoo-invalid-field-${parametro}`;

//   const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//   svg.setAttribute("viewBox", "-2 -2 24 24");
//   svg.setAttribute("width", "24");
//   svg.setAttribute("height", "24");
//   svg.setAttribute("aria-hidden", "true");
//   svg.classList.add("wc-block-components-validation-error__icon");

//   const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
//   path.setAttribute(
//     "d",
//     "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.35-6.46H8.52l.35 6.46h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35-.82.12-1.07.35-.37.55-.37.97c0 .41.13.73.38.96.26.23.61.34 1.06.34s.8-.11 1.05-.34z"
//   );

//   svg.appendChild(path);

//   const span = document.createElement("span");
//   span.textContent = message;

//   p.appendChild(svg);
//   p.appendChild(span);
//   div.appendChild(p);

//   return div;
// }

// export const showErrorMessage = (message, field) => {
//   const errorElement = createErrorMessage(message, field);
//   console.log('showErrorMessage called with field:', field, 'and message:', message);
//   const targetContainer = getTargetContainer(field); // DIV
//   console.log('Target container:', targetContainer);
//   const targetInputValue = getTargetInput(field)?.value; // INPUT VALUE
//   console.log('Target input value:', targetInputValue);
//   const targetCheckbox = getTargetInput("checkbox"); // Ficoo checkbox
//   console.log('Target checkbox:', targetCheckbox);

//   if (targetContainer) {
//     removeErrorMessage(field);
//   }

//   if (targetContainer && targetInputValue && targetCheckbox?.checked) {
//     targetContainer.appendChild(errorElement);
//     targetContainer.classList.add("has-error");
//     logger.p("AGGIUNTO errore a  " + field);
//   }
// };

// export const removeErrorMessage = (field) => {
//   const targetContainer = getTargetContainer(field);

//   if (targetContainer) {
//     const errorElement = targetContainer.querySelector(
//       ".wc-block-components-validation-error"
//     );
//     if (errorElement) {
//       logger.p("RIMOSSO errore da  " + field);
//       errorElement.remove();
//     }
//     targetContainer.classList.remove("has-error");
//   }
// };

// // -----------------------------
// //  SUCCESS MSG
// // -----------------------------
// const createSuccessMessage = (message, parametro) => {
//   const div = document.createElement("div");
//   div.classList.add("wc-block-components-validation-success");
//   div.setAttribute("role", "alert");
//   div.style.color = "#008000";

//   const p = document.createElement("span");
//   p.id = `ficoo-success-field-${parametro}`;

//   const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//   svg.setAttribute("viewBox", "-2 -6 24 24");
//   svg.setAttribute("width", "20");
//   svg.setAttribute("height", "20");
//   svg.setAttribute("aria-hidden", "true");
//   svg.classList.add("wc-block-components-validation-success__icon");
//   svg.style.fill = "#008000";

//   const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
//   path.setAttribute(
//     "d",
//     "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm-1.13 12.38l6.35-6.36-1.42-1.42-4.93 4.93-2.35-2.35-1.42 1.42z"
//   );

//   svg.appendChild(path);

//   const span = document.createElement("span");
//   span.textContent = message;

//   p.appendChild(svg);
//   p.appendChild(span);
//   div.appendChild(p);

//   return div;
// };

// /**
//  * Show a success message.
//  * @param {*} message 'Message to show
//  * @param {*} field 'Field to associate the message with
//  * @param {*} time 'Duration in seconds to show the message for (optional)
//  */
// export const showSuccessMessage = (message, field, time = null) => {
//   const successElement = createSuccessMessage(message, field);
//   const targetContainer = getTargetContainer(field);

//   if (targetContainer) {
//     removeErrorMessage(field);

//     const existingSuccess = targetContainer.querySelector(
//       ".wc-block-components-validation-success"
//     );

//     if (existingSuccess) {
//       existingSuccess.remove();
//     }

//     targetContainer.appendChild(successElement);

//     // add timeout.
//     if (time) {
//       setTimeout(() => {
//         if (successElement && successElement.parentNode) {
//           successElement.remove();
//         }
//       }, time * 1000);
//     }
//   }
// };

// export const removeSuccessMessage = (field) => {
//   const targetContainer = getTargetContainer(field);

//   if (targetContainer) {
//     const successElement = targetContainer.querySelector(
//       ".wc-block-components-validation-success"
//     );
//     if (successElement) {
//       logger.p("RIMOSSO messaggio da  " + field);
//       successElement.remove();
//     }
//   }
// };

// ////// SPINNER

// const createSpinner = (parametro) => {
//   const div = document.createElement("div");
//   div.classList.add("wc-block-components-validation-loading");
//   div.setAttribute("role", "alert");
//   div.style.marginTop = "8px"; // Aggiungo margine superiore

//   const spanf = document.createElement("span");
//   spanf.id = `ficoo-loading-field-${parametro}`;
//   spanf.style.display = "flex"; // Uso flex per centrare verticalmente
//   spanf.style.alignItems = "center"; // Centro verticalmente
//   spanf.style.gap = "8px"; // Spazio tra icona e testo

//   const style = document.createElement("style");
//   style.textContent = `
//         @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//         }
//         .ficoo-spinner {
//             animation: spin 1s linear infinite;
//             transform-origin: center;
//         }
//     `;
//   document.head.appendChild(style);

//   const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//   svg.setAttribute("class", "ficoo-spinner");
//   svg.setAttribute("width", "16");
//   svg.setAttribute("height", "16");
//   svg.setAttribute("viewBox", "0 0 40 40");
//   svg.setAttribute("aria-hidden", "true");

//   const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
//   path1.setAttribute("fill", "none");
//   path1.setAttribute("stroke", "#96588a");
//   path1.setAttribute("stroke-width", "4");
//   path1.setAttribute("stroke-linecap", "round");
//   path1.setAttribute("d", "M20,2 A18,18 0 0 1 32.727,32.727");

//   const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
//   path2.setAttribute("fill", "none");
//   path2.setAttribute("stroke", "#3498db");
//   path2.setAttribute("stroke-width", "4");
//   path2.setAttribute("stroke-linecap", "round");
//   path2.setAttribute("d", "M32.727,32.727 A18,18 0 0 1 2,20");

//   svg.appendChild(path1);
//   svg.appendChild(path2);

//   const span = document.createElement("span");
//   span.textContent = __("Checking..", "ficoo-smart-connector-pro");

//   spanf.appendChild(svg);
//   spanf.appendChild(span);
//   div.appendChild(spanf);

//   return div;
// };

// export const showSpinner = (field) => {
//   console.warn('FicooValidator: Using basic spinner. Install Pro for advanced features.');
//   const spinnerElement = createSpinner(field);
//   const targetContainer = getTargetContainer(field);

//   if (targetContainer) {
//     removeErrorMessage(field);
//     removeSuccessMessage(field);

//     targetContainer.appendChild(spinnerElement);
//   }
// };

// export const removeSpinner = (field) => {
//   const targetContainer = getTargetContainer(field);

//   if (targetContainer) {
//     const spinnerElement = targetContainer.querySelector(
//       ".wc-block-components-validation-loading"
//     );
//     if (spinnerElement) {
//       spinnerElement.remove();
//     }
//   }
// };

// // const createSpinner = (parametro) => {
// //     const div = document.createElement('div');
// //     div.classList.add('wc-block-components-validation-loading');
// //     div.setAttribute('role', 'alert');
// //     div.setAttribute('style', 'margin-top:0.5em');

// //     const p = document.createElement('p');
// //     p.id = `ficoo-loading-field-${parametro}`;

// //     const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
// //     svg.setAttribute('viewBox', '0 0 24 24');
// //     svg.setAttribute('width', '20');
// //     svg.setAttribute('height', '20');
// //     svg.setAttribute('aria-hidden', 'true');
// //     svg.classList.add('wc-block-components-validation-loading__icon');
// //     svg.style.animation = 'spin 1s linear infinite';

// //     // Aggiunge lo stile per la rotazione
// //     const style = document.createElement('style');
// //     style.textContent = `
// //         @keyframes spin {
// //             0% { transform: rotate(0deg); }
// //             100% { transform: rotate(360deg); }
// //         }
// //         .wc-block-components-validation-loading__icon path {
// //             fill: url(#ficooGradient);
// //         }
// //     `;
// //     document.head.appendChild(style);

// //     // Definiamo un linearGradient con due "mezze" ben distinte
// //     const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
// //     const gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
// //     gradient.setAttribute('id', 'ficooGradient');
// //     // Da sinistra a destra
// //     gradient.setAttribute('x1', '0%');
// //     gradient.setAttribute('y1', '0%');
// //     gradient.setAttribute('x2', '100%');
// //     gradient.setAttribute('y2', '0%');

// //     // Prima metà violetto
// //     const stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
// //     stop1.setAttribute('offset', '0%');
// //     stop1.setAttribute('style', 'stop-color:#96588a;');

// //     const stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
// //     stop2.setAttribute('offset', '50%');
// //     stop2.setAttribute('style', 'stop-color:#96588a;');

// //     // Seconda metà azzurro
// //     const stop3 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
// //     stop3.setAttribute('offset', '50%');
// //     stop3.setAttribute('style', 'stop-color:#3498db;');

// //     const stop4 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
// //     stop4.setAttribute('offset', '100%');
// //     stop4.setAttribute('style', 'stop-color:#3498db;');

// //     gradient.appendChild(stop1);
// //     gradient.appendChild(stop2);
// //     gradient.appendChild(stop3);
// //     gradient.appendChild(stop4);

// //     defs.appendChild(gradient);
// //     svg.appendChild(defs);

// //     // Il path del simbolo di caricamento
// //     const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
// //     path.setAttribute('d', 'M12 2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8V2zM4.93 14A10 10 0 0 0 12 22v-2a8 8 0 0 1-5.66-2.34L4.93 14z');
// //     svg.appendChild(path);

// //     const span = document.createElement('span');
// //     span.textContent = 'Verifica in corso...';

// //     p.appendChild(svg);
// //     p.appendChild(span);
// //     div.appendChild(p);

// //     return div;
// // }


// -----------------------------
//  GET FIELDS.
// -----------------------------

import { ficooInput, ficooDiv, woocommerceFields, ficooShippingAddressDiv, ficooBillingAddressDiv } from "./fields-selectors.js";
import { __, _x, _n, sprintf } from "@wordpress/i18n";

import { logger } from "./logger.js";

// Used to append error div.
const getTargetContainer = (field) => {
  switch (field) {
    case "vat":
      return ficooDiv.vat;
    case "taxcode":
      return ficooDiv.taxcode;
    case "pec":
      return ficooDiv.emailpec;
    case "reccode":
      return ficooDiv.reccode;
    case "vatShipping":
      return ficooShippingAddressDiv.vat;
      case "taxcodeShipping":
      return ficooShippingAddressDiv.taxcode;
    case "pecShipping":
      return ficooShippingAddressDiv.emailpec;
    case "reccodeShipping":
      return ficooShippingAddressDiv.reccode;
    case "vatBilling":
      return ficooBillingAddressDiv.vat;
      case "taxcodeBilling":
      return ficooBillingAddressDiv.taxcode;
    case "pecBilling":
      return ficooBillingAddressDiv.emailpec;
    case "reccodeBilling":
      return ficooBillingAddressDiv.reccode;
    case "woototalwrap":
      return woocommerceFields.totalwrapper;
    default:
      return null;
  }
};

const getTargetInput = (field) => {
  switch (field) {
    case "vat":
      return ficooInput.vat;
    case "taxcode":
      return ficooInput.taxcode;
    case "pec":
      return ficooInput.emailpec;
    case "reccode":
      return ficooInput.reccode;
    case "checkbox":
      return ficooInput.checkbox;
    default:
      return null;
  }
};

// -----------------------------
//  ERROR MSG
// -----------------------------

function createErrorMessage(message, parametro) {
  const div = document.createElement("div");
  div.classList.add("wc-block-components-validation-error");
  div.setAttribute("role", "alert");

  const p = document.createElement("p");
  p.id = `ficoo-invalid-field-${parametro}`;

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "-2 -2 24 24");
  svg.setAttribute("width", "24");
  svg.setAttribute("height", "24");
  svg.setAttribute("aria-hidden", "true");
  svg.classList.add("wc-block-components-validation-error__icon");

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute(
    "d",
    "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.35-6.46H8.52l.35 6.46h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35-.82.12-1.07.35-.37.55-.37.97c0 .41.13.73.38.96.26.23.61.34 1.06.34s.8-.11 1.05-.34z"
  );

  svg.appendChild(path);

  const span = document.createElement("span");
  span.textContent = message;

  p.appendChild(svg);
  p.appendChild(span);
  div.appendChild(p);

  return div;
}

export const showErrorMessage = (message, field) => {
  const errorElement = createErrorMessage(message, field);
  console.log('showErrorMessage called with field:', field, 'and message:', message);
  const targetContainer = getTargetContainer(field); // DIV
  console.log('Target container:', targetContainer);
  const targetInputValue = getTargetInput(field)?.value; // INPUT VALUE
  console.log('Target input value:', targetInputValue);
  const targetCheckbox = getTargetInput("checkbox"); // Ficoo checkbox
  console.log('Target checkbox:', targetCheckbox);

  if (targetContainer) {
    removeErrorMessage(field);
  }

  if (targetContainer && targetInputValue && targetCheckbox?.checked) {
    targetContainer.appendChild(errorElement);
    targetContainer.classList.add("has-error");
    logger.p("AGGIUNTO errore a  " + field);
  }
};

export const removeErrorMessage = (field) => {
  const targetContainer = getTargetContainer(field);

  if (targetContainer) {
    const errorElement = targetContainer.querySelector(
      ".wc-block-components-validation-error"
    );
    if (errorElement) {
      logger.p("RIMOSSO errore da  " + field);
      errorElement.remove();
    }
    targetContainer.classList.remove("has-error");
  }
};

// -----------------------------
//  SUCCESS MSG
// -----------------------------
const createSuccessMessage = (message, parametro) => {
  const div = document.createElement("div");
  div.classList.add("wc-block-components-validation-success");
  div.setAttribute("role", "alert");
  div.style.color = "#008000";

  const p = document.createElement("span");
  p.id = `ficoo-success-field-${parametro}`;

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "-2 -6 24 24");
  svg.setAttribute("width", "20");
  svg.setAttribute("height", "20");
  svg.setAttribute("aria-hidden", "true");
  svg.classList.add("wc-block-components-validation-success__icon");
  svg.style.fill = "#008000";

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute(
    "d",
    "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm-1.13 12.38l6.35-6.36-1.42-1.42-4.93 4.93-2.35-2.35-1.42 1.42z"
  );

  svg.appendChild(path);

  const span = document.createElement("span");
  span.textContent = message;

  p.appendChild(svg);
  p.appendChild(span);
  div.appendChild(p);

  return div;
};

/**
 * Show a success message.
 * @param {*} message 'Message to show
 * @param {*} field 'Field to associate the message with
 * @param {*} time 'Duration in seconds to show the message for (optional)
 */
export const showSuccessMessage = (message, field, time = null) => {
  const successElement = createSuccessMessage(message, field);
  const targetContainer = getTargetContainer(field);

  if (targetContainer) {
    removeErrorMessage(field);

    const existingSuccess = targetContainer.querySelector(
      ".wc-block-components-validation-success"
    );

    if (existingSuccess) {
      existingSuccess.remove();
    }

    targetContainer.appendChild(successElement);

    // add timeout.
    if (time) {
      setTimeout(() => {
        if (successElement && successElement.parentNode) {
          successElement.remove();
        }
      }, time * 1000);
    }
  }
};

export const removeSuccessMessage = (field) => {
  const targetContainer = getTargetContainer(field);

  if (targetContainer) {
    const successElement = targetContainer.querySelector(
      ".wc-block-components-validation-success"
    );
    if (successElement) {
      logger.p("RIMOSSO messaggio da  " + field);
      successElement.remove();
    }
  }
};

////// SPINNER

const createSpinner = (parametro) => {
  const div = document.createElement("div");
  div.classList.add("wc-block-components-validation-loading");
  div.setAttribute("role", "alert");
  div.style.marginTop = "8px"; // Aggiungo margine superiore

  const spanf = document.createElement("span");
  spanf.id = `ficoo-loading-field-${parametro}`;
  spanf.style.display = "flex"; // Uso flex per centrare verticalmente
  spanf.style.alignItems = "center"; // Centro verticalmente
  spanf.style.gap = "8px"; // Spazio tra icona e testo

  const style = document.createElement("style");
  style.textContent = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        .ficoo-spinner {
            animation: spin 1s linear infinite;
            transform-origin: center;
        }
    `;
  document.head.appendChild(style);

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("class", "ficoo-spinner");
  svg.setAttribute("width", "16");
  svg.setAttribute("height", "16");
  svg.setAttribute("viewBox", "0 0 40 40");
  svg.setAttribute("aria-hidden", "true");

  const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path1.setAttribute("fill", "none");
  path1.setAttribute("stroke", "#96588a");
  path1.setAttribute("stroke-width", "4");
  path1.setAttribute("stroke-linecap", "round");
  path1.setAttribute("d", "M20,2 A18,18 0 0 1 32.727,32.727");

  const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path2.setAttribute("fill", "none");
  path2.setAttribute("stroke", "#3498db");
  path2.setAttribute("stroke-width", "4");
  path2.setAttribute("stroke-linecap", "round");
  path2.setAttribute("d", "M32.727,32.727 A18,18 0 0 1 2,20");

  svg.appendChild(path1);
  svg.appendChild(path2);

  const span = document.createElement("span");
  span.textContent = __("Checking..", "ficoo-smart-connector-core");

  spanf.appendChild(svg);
  spanf.appendChild(span);
  div.appendChild(spanf);

  return div;
};

export const showSpinner = (field) => {
  const spinnerElement = createSpinner(field);
  const targetContainer = getTargetContainer(field);

  if (targetContainer) {
    removeErrorMessage(field);
    removeSuccessMessage(field);

    targetContainer.appendChild(spinnerElement);
  }
};

export const removeSpinner = (field) => {
  const targetContainer = getTargetContainer(field);

  if (targetContainer) {
    const spinnerElement = targetContainer.querySelector(
      ".wc-block-components-validation-loading"
    );
    if (spinnerElement) {
      spinnerElement.remove();
    }
  }
};

// const createSpinner = (parametro) => {
//     const div = document.createElement('div');
//     div.classList.add('wc-block-components-validation-loading');
//     div.setAttribute('role', 'alert');
//     div.setAttribute('style', 'margin-top:0.5em');

//     const p = document.createElement('p');
//     p.id = `ficoo-loading-field-${parametro}`;

//     const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//     svg.setAttribute('viewBox', '0 0 24 24');
//     svg.setAttribute('width', '20');
//     svg.setAttribute('height', '20');
//     svg.setAttribute('aria-hidden', 'true');
//     svg.classList.add('wc-block-components-validation-loading__icon');
//     svg.style.animation = 'spin 1s linear infinite';

//     // Aggiunge lo stile per la rotazione
//     const style = document.createElement('style');
//     style.textContent = `
//         @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//         }
//         .wc-block-components-validation-loading__icon path {
//             fill: url(#ficooGradient);
//         }
//     `;
//     document.head.appendChild(style);

//     // Definiamo un linearGradient con due "mezze" ben distinte
//     const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
//     const gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
//     gradient.setAttribute('id', 'ficooGradient');
//     // Da sinistra a destra
//     gradient.setAttribute('x1', '0%');
//     gradient.setAttribute('y1', '0%');
//     gradient.setAttribute('x2', '100%');
//     gradient.setAttribute('y2', '0%');

//     // Prima metà violetto
//     const stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
//     stop1.setAttribute('offset', '0%');
//     stop1.setAttribute('style', 'stop-color:#96588a;');

//     const stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
//     stop2.setAttribute('offset', '50%');
//     stop2.setAttribute('style', 'stop-color:#96588a;');

//     // Seconda metà azzurro
//     const stop3 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
//     stop3.setAttribute('offset', '50%');
//     stop3.setAttribute('style', 'stop-color:#3498db;');

//     const stop4 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
//     stop4.setAttribute('offset', '100%');
//     stop4.setAttribute('style', 'stop-color:#3498db;');

//     gradient.appendChild(stop1);
//     gradient.appendChild(stop2);
//     gradient.appendChild(stop3);
//     gradient.appendChild(stop4);

//     defs.appendChild(gradient);
//     svg.appendChild(defs);

//     // Il path del simbolo di caricamento
//     const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
//     path.setAttribute('d', 'M12 2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8V2zM4.93 14A10 10 0 0 0 12 22v-2a8 8 0 0 1-5.66-2.34L4.93 14z');
//     svg.appendChild(path);

//     const span = document.createElement('span');
//     span.textContent = 'Verifica in corso...';

//     p.appendChild(svg);
//     p.appendChild(span);
//     div.appendChild(p);

//     return div;
// }
